import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { Skeleton } from 'primeng/skeleton';
@Component({
  selector: 'app-card-bar-chart',
  standalone: true,
  imports: [ChartModule, Skeleton, CommonModule],
  templateUrl: './card-bar-chart.component.html',
  styleUrl: './card-bar-chart.component.css',
})
export class CardBarChartComponent {
  @Input({ required: true }) isLoading: boolean = false;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) value!: string;
  @Input({ required: true }) detailTitle!: string;
  @Input({ required: true }) detailValue!: string;
  @Input({ required: true }) detailColor!: string;
  @Input({ required: true }) detailBackgroundColor!: string;
  @Input({ required: true }) borderBottomColor!: string;
  @Input({ required: true }) chartLabels!: string[];
  @Input({ required: true }) chartData!: number[];
  @Input({ required: true }) chartBorderColor!: string;
  @Input({ required: true }) chartBackgroundColor!: string;
  @Input() tooltip1: string = '';
  @Input() tooltip2: string = '';
  @Input() tooltip3: string = '';

  data: any;
  options: any;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.initChart();
  }

  initChart() {
    this.data = {
      labels: this.chartLabels,
      datasets: [
        {
          label: '',
          data: this.chartData,
          borderColor: this.chartBorderColor,
          backgroundColor: this.chartBackgroundColor,
          borderWidth: 1,
          barThickness: 10,
        },
      ],
    };

    this.options = {
      maintainAspectRatio: false,
      responsive: true,
      aspectRatio: 4.5,
      display: false,
      plugins: {
        title: {
          display: false,
        },
        legend: {
          display: false,
        },
      },

      scales: {
        x: {
          ticks: {
            display: false,
          },
          grid: {
            display: false,
          },
          border: {
            display: false,
          },
        },
        y: {
          ticks: {
            display: false,
          },
          grid: {
            display: false,
          },
          border: {
            display: false,
          },
        },
      },
    };

    this.cd.markForCheck();
  }
}
